import React from 'react';
import { BaseComponent } from '../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { selectVehicle } from '../../../selectors';
import { EditVehicleOptions } from './EditVehicleOptions';
import cn from 'classnames';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import styles from './OptionsStep.module.css';

const Container = styled.div`
  width: 100%;

  .btn-block {
    padding: 30px;
  }
`;

class OptionsStepComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    return (
      <Container className={cn(styles.containerCol, '')}>
        <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
          <h2>{this.lbl('vehicle.create.columns.options')}</h2>
          <EditVehicleOptions vehicle={this.props.vehicle} optionStep/>

          <div className="d-flex gap-2 justify-content-end mt-2 mb-3">
            <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
              {this.lbl('previous')}
            </ButtonComponent>

            <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)}>
              {this.lbl('save')}
            </ButtonComponent>
          </div>
        </div>
      </Container>
    );
  }
}

OptionsStepComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OptionsPage = compose(withConnect, withRouter)(OptionsStepComp);
